
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cashback/dab",
      function () {
        return require("private-next-pages/cashback/dab.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cashback/dab"])
      });
    }
  